var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptoecon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t.cls-1-cryptoecon{fill:#bcefff;}\r\n\t\t\t.cls-2-cryptoecon{fill:#c3cb3e;}\r\n\t\t\t.cls-3-cryptoecon{fill:#2ea8e2;}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.19,605.35c-25.58,0-40.33-17.61-40.33-45.09s15.7-44.25,40.8-44.25c20.22,0,34.02,11.54,36.88,29.5h-16.18c-3.21-12.02-11.3-15.94-20.82-15.94-13.09,0-23.08,10.71-23.08,30.69s9.99,31.53,22.48,31.53c10.23,0,18.68-4.64,21.41-16.3h16.18c-2.26,17.37-16.65,29.86-37.35,29.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,555.27c-8.09,0-13.44,2.97-13.44,14.99v33.55h-16.42v-64h16.18v11.18c3.69-7.85,9.52-11.06,16.89-11.06,1.07,0,2.5,.12,3.57,.24v15.47c-2.38-.24-4.4-.36-6.78-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,612.01h6.19c5.47,0,7.97,.12,10.71-6.66l.71-1.78-24.51-63.76h17.96l14.51,46.15,14.87-46.15h16.65l-23.44,62.1c-7.49,19.87-10.82,22.72-26.77,22.72h-6.9v-12.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26,539.8h16.42v8.21c3.45-5.95,10.35-9.64,18.44-9.64,15.47,0,27.84,13.32,27.84,33.43s-12.73,33.55-27.96,33.55c-6.66,0-14.28-2.62-18.32-9.64v28.91h-16.42v-84.82Zm30.81,11.18c-9.04,0-14.99,7.97-14.99,20.82s5.95,20.94,14.99,20.94c8.45,0,14.63-8.33,14.63-20.82s-6.19-20.94-14.63-20.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,522.44v17.37h13.32v11.3h-13.32v33.07c0,6.54,2.26,7.85,8.09,7.85h5v11.78h-12.02c-14.63,0-17.49-4.52-17.49-17.25v-35.45h-9.04v-11.3h9.04v-17.37h16.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.83,538.37c16.18,0,32.12,11.07,32.12,33.55s-15.94,33.43-32.12,33.43-32.12-10.94-32.12-33.43,15.94-33.55,32.12-33.55Zm0,54.13c9.04,0,15.46-7.26,15.46-20.58s-6.42-20.7-15.46-20.7-15.46,7.26-15.46,20.7,6.42,20.58,15.46,20.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.57,517.56v13.8h-45.8v21.41h43.3v13.8h-43.3v23.43h45.8v13.8h-62.81v-86.25h62.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.85,561.69c-1.19-6.07-7.14-10.59-13.32-10.59-8.57,0-15.35,7.26-15.35,20.58s6.42,20.94,15.46,20.94c5.59,0,11.66-2.86,13.8-10.59h15.7c-3.81,17.49-17.13,23.32-30.33,23.32-19.15,0-31.41-14.15-31.41-33.43s12.97-33.55,32.12-33.55c13.32,0,26.89,7.38,29.03,23.32h-15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.33,538.37c16.18,0,32.12,11.07,32.12,33.55s-15.94,33.43-32.12,33.43-32.12-10.94-32.12-33.43,15.94-33.55,32.12-33.55Zm0,54.13c9.04,0,15.46-7.26,15.46-20.58s-6.42-20.7-15.46-20.7-15.46,7.26-15.46,20.7,6.42,20.58,15.46,20.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.88,538.37c15.35,0,22.13,9.4,22.13,25.1v40.33h-16.42v-36.76c0-8.33-1.78-15.47-11.06-15.47-10.82,0-13.2,8.8-13.2,18.92v33.31h-16.42v-64h16.42v8.44c3.69-6.42,10.71-9.87,18.56-9.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.15,590v13.8h-59v-86.25h17.01v72.45h41.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.5,586.56c0-15.11,17.01-19.63,42.11-22.49v-1.07c0-9.87-5.35-13.32-12.02-13.32-6.3,0-11.54,3.33-11.9,10.35h-15.35c1.19-12.61,11.66-21.89,28.07-21.89,15.23,0,27.6,6.54,27.6,28.19,0,2.02-.24,10.47-.24,16.3,0,10.11,.71,15.82,1.9,21.17h-15.11c-.48-2.02-.83-4.88-1.07-7.97-4.52,6.66-11.3,9.52-20.94,9.52-12.25,0-23.08-7.14-23.08-18.79Zm16.89-.83c0,4.64,3.69,8.45,11.06,8.45,10.23,0,14.63-5.59,14.63-14.87v-4.76c-18.32,1.9-25.7,4.05-25.7,11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.69,517.56h16.42v30.45c3.45-5.95,10.35-9.64,18.44-9.64,15.47,0,27.84,13.32,27.84,33.43s-12.61,33.55-27.84,33.55c-6.66,0-14.39-2.62-18.44-9.64v8.09h-16.42v-86.25Zm30.81,33.43c-9.04,0-14.99,7.97-14.99,20.82s5.95,20.94,14.99,20.94c8.45,0,14.63-8.33,14.63-20.82s-6.19-20.94-14.63-20.94Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M432.16,298.95l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M399.29,280.03l32.87-18.91,32.87,18.91-32.87,18.91-32.87-18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M399.29,317.85l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M366.42,298.95l32.87-18.91,32.87,18.91-32.87,18.91-32.87-18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M366.42,336.78l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M333.55,317.86l32.87,18.91v37.83l-32.87-18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M333.55,317.86l32.87-18.91,32.87,18.91-32.87,18.91-32.87-18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M405.86,246.59l-32.87,18.91v37.83l32.87-18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M372.99,265.5l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M340.12,246.59l32.87,18.91v37.83l-32.87-18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M372.99,228.22l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M340.12,209.31l32.87,18.91v37.83l-32.87-18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M438.73,153.12l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M405.86,134.21l32.87-18.91,32.87,18.91-32.87,18.91-32.87-18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M405.86,172.03l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M372.99,153.12l32.87-18.91,32.87,18.91-32.87,18.91-32.87-18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M340.12,172.03l32.87,18.91v37.83l-32.87-18.91v-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M340.12,172.03l32.87-18.91,32.87,18.91-32.87,18.91-32.87-18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M372.99,190.95l32.87-18.91v37.83l-32.87,18.91v-37.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M563.72,336.78l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M563.72,298.95l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M596.59,355.68l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M596.59,317.86l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M497.98,301.14l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M530.85,282.23l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M497.98,263.31l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M596.83,384.96l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M563.96,366.04l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M564.56,403.6l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M531.69,384.68l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M434.43,403.75l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M434.43,365.94l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M467,422.49l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M466.56,384.41l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M499.43,441.15l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M532.3,422.24l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M499.43,403.32l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M629.46,374.6l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M662.33,355.69l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M629.46,336.78l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M590.02,284.42l32.87,18.91v-37.83l-32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M622.89,303.33l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M655.76,284.42l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M622.89,266.05l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M655.76,247.14l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M557.15,190.95l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M557.15,153.12l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M590.02,209.86l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M590.02,172.03l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M655.76,209.86l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M622.89,190.95l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M497.98,225.48l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M530.85,206.57l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M497.98,188.2l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M530.85,169.29l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M497.98,150.92l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cryptoecon",
    d: "M530.85,132.01l-32.87,18.91v-37.83l32.87-18.91v37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cryptoecon",
    d: "M497.98,113.1l-32.87-18.91,32.87-18.91,32.87,18.91-32.87,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cryptoecon",
    d: "M622.89,228.77l-32.87-18.91v-37.83l32.87,18.91v37.83Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoecon);
export default __webpack_public_path__ + "static/media/cryptoecon.792f2c59f85f27242c96f70ec1975e07.svg";
export { ForwardRef as ReactComponent };